import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import UserContext from "../../context/user-context";
import useProviderAuthorization from "../../hooks/useProviderAuthorization";
import { useStore } from "../../hooks/useStore";
import { addAuthorization } from "../../store/actions/userAction";
import { convertAuthorization } from "../../store/functions/userFunction";
import { AuthorizationType } from "../../store/types/userTypes";

type DialogProviderProps = {
  open: boolean;
  close: () => void;
  providers: any[];
  lotName: string;
  actionCancel?: () => void;
};

export const DialogProviderAuthorization = ({
  open,
  close,
  providers,
  lotName,
  actionCancel,
}: DialogProviderProps) => {
  const [selected, setSelected] = useState<any>(null);
  const { authStore } = useStore();
  const { residents } = authStore;
  const { dispatch } = useContext(UserContext);
  const { getProfessionTypeById } = useProviderAuthorization();

  const select = (provider: any) => {
    setSelected(provider);
  };

  const handleCancel = () => {
    close();
    if (actionCancel) actionCancel();
  };

  const handleConfirm = () => {
    close();
    selected.host = residents.find((resident) => resident.id === selected.host);
    selected.providerType = getProfessionTypeById(selected.providerType);
    selected.isEnableMark = true;
    dispatch(
      addAuthorization(
        convertAuthorization(selected, {
          type: AuthorizationType.current,
          mark: true,
        })
      )
    );
  };
  return (
    <Dialog
      open={open}
      onClose={close}
      aria-labelledby="customized-dialog-title"
    >
      <DialogTitle id="customized-dialog-title">{`Proveedores autorizados - ${lotName}`}</DialogTitle>
      <DialogContent dividers style={{ paddingTop: 0 }}>
        <List>
          {providers.map((provider) => (
            <ListItem
              key={provider.id}
              button
              onClick={() => select(provider)}
            >
              <ListItemIcon>
                <Radio checked={selected?.id === provider.id} />
              </ListItemIcon>
              <ListItemText
                id={selected?.id}
                primary={`${provider.providerName} - ${
                  getProfessionTypeById(provider.providerType)?.name || ""
                }`}
              />
            </ListItem>
          ))}
        </List>
        <Typography>Comentarios del residente</Typography>
        <TextField
          disabled
          style={{ width: "100%" }}
          id="filled-multiline-static"
          multiline
          minRows={4}
          value={selected?.comments}
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} variant="outlined" color="primary">
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="primary"
          disabled={selected === null}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
